import {
  Button,
  Flex,
  Space,
} from 'antd'
import React, { useState } from 'react'

import { useAppSelector } from '@/redux/utils'

import styles from '../settings.module.css'

import SalesSettingsDisplay from './components/sales-settings-display'
import SalesSettingsEditor from './components/sales-settings-editor'
import History from './history'

export default function SalesSettings() {
  const salesSettings = useAppSelector(state => state.salesSettings.activatedSalesSettings)
  const [showHistory, setShowHistory] = useState(false)
  const [editorOpen, setEditorOpen] = useState(false)

  if (showHistory) {
    return <History onBack={() => setShowHistory(false)} />
  }

  return (
    <Flex vertical className={styles.settingsSection}>
      <Flex className="settings-content-header">
        <b className="settings-header-title">Sales settings</b>
        <Space>
          <Button type="link" onClick={() => setShowHistory(true)}>
            Settings History
          </Button>
          <Button type="primary" onClick={() => setEditorOpen(true)}>
            Edit
          </Button>
        </Space>
      </Flex>
      <div className="settings-content">
        {salesSettings && (
          <SalesSettingsDisplay salesSettings={salesSettings} showEffectedAt />
        )}
      </div>
      {salesSettings && <SalesSettingsEditor
        defaultValue={salesSettings}
        open={editorOpen}
        setOpen={setEditorOpen}
      />}
    </Flex>
  )
}
